import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import FirstForm from '../Forms/FirstForm';
import SecondForm from '../Forms/SecondForm';
import ThirdForm from '../Forms/ThirdForm';
import { StepIconProps } from '@mui/material';
import axios from "axios";


const baseURL = "https://dev.globspot.tech/Api/LandingPageForm/";
const headers = {
  'Content-Type': 'application/json',
  'Authorization': 'Basic aXZhbm1hYzoxMjM0NTY=',
};
const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: 'linear-gradient(95deg, rgb(33,150,243) 0%, rgb(30,136,229) 50%, rgb(21,101,192) 100%)',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: 'linear-gradient(95deg, rgb(33,150,243) 0%, rgb(30,136,229) 50%, rgb(21,101,192) 100%)',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: ownerState.active || ownerState.completed ? '#2196F3' : '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...(ownerState.active && {
    backgroundImage: 'linear-gradient(136deg, rgb(33,150,243) 0%, rgb(30,136,229) 50%, rgb(21,101,192) 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  }),
  ...(ownerState.completed && {
    backgroundImage: 'linear-gradient(136deg, rgb(33,150,243) 0%, rgb(30,136,229) 50%, rgb(21,101,192) 100%)',
  }),
}));
function ColorlibStepIcon(props: StepIconProps) {
  const { active, completed, icon } = props;
  const icons: { [index: string]: React.ReactElement } = {
    1: <PersonIcon />,
    2: <BusinessIcon />,
    3: <LocationOnIcon />,
  };
  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }}>
      {icons[String(icon)]}
    </ColorlibStepIconRoot>
  );
}

const steps = ['Información personal', 'Compañía', 'Dispositivos'];

interface CombinedStepperProps {
  handleClose: () => void; 
  showAlert: (message: string, severity: 'success' | 'error') => void; 

}

export default function CombinedStepper({ handleClose,showAlert }:CombinedStepperProps) {
  const [activeStep, setActiveStep] = React.useState(0);
  const [formData, setFormData] = React.useState({}); 
  const [isValid, setIsValid] = React.useState(true); 
  const [errorMessage, setErrorMessage] = React.useState(''); 

  const handleNext = () => {
    if (isValid) {
      setActiveStep((prev) => prev + 1);
      setErrorMessage('');
    } else {
      setErrorMessage('* Por favor, completa todos los campos.');    }
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
    setErrorMessage('');
  }

  // Función para actualizar formData con los datos de cada formulario
  const updateData = (newData: Record<string, any>) => {
    setFormData((prev) => ({ ...prev, ...newData }));
  };

  // Función para validar formularios
  const validateForm = (isValid: boolean) => {
    setIsValid(isValid);
  };

  // Muestra el formulario correspondiente en cada paso
  const renderStepContent = (step: number) => {
    switch (step) {
      case 0:
        return <FirstForm data={formData} updateData={updateData} validateForm={validateForm} />;
      case 1:
        return <SecondForm data={formData} updateData={updateData} validateForm={validateForm} />;
      case 2:
        return <ThirdForm data={formData} updateData={updateData} validateForm={validateForm} />;
      default:
        return null;
    }
  };

  // Acción al terminar los pasos, enviar formulario
  const handleFinish = () => {
    if (isValid) {
      console.log("Datos finales del formulario:", formData);
      axios.post(baseURL, formData, {headers}).then((response) => {
        showAlert('Cupón enviado correctamente!', 'success');
      }).catch(error => {
        showAlert('Error al enviar el cupón', 'error');
      });
      handleClose();
    } else {
      setErrorMessage('* Por favor, completa todos los campos.');    }
  };
  
  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={4}>
        <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
          {steps.map((label, index) => (
            <Step key={label} completed={activeStep > index}>
              <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
          {renderStepContent(activeStep)}
          {errorMessage && <Typography color="error">{errorMessage}</Typography>} 
          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
            <Button color="inherit" variant="outlined" disabled={activeStep === 0} onClick={handleBack} sx={{ mr: 1, borderRadius: '15px' }}>Atrás</Button>
            <Box sx={{ flex: '1 1 auto' }} />
            <Button
              onClick={activeStep === steps.length - 1 ? handleFinish : handleNext}
              variant={activeStep === steps.length - 1 ? 'contained' : 'outlined'}
              color={activeStep === steps.length - 1 ? 'success' : 'info'}
              sx={{ borderRadius: '15px' }}
            >
              {activeStep === steps.length - 1 ? 'Enviar' : 'Siguiente'}
            </Button>

          </Box>
      </Stack>
    </Box>
  );
}
